declare var window: any;

var FormHelper = {
    trim<T extends Record<string, any>>(object: T): T {
        for (const key in object) {
            if (typeof object[key] === "string") {
                object[key] = object[key].trim();
            }
        }
        return object;
    }
}

export default FormHelper;